import { makeStyles } from '../../themes';

interface TruckIconProps {
  className?: string;
}

function TruckDrivingIcon({ className }: TruckIconProps) {
  return (
    <svg
      width='26'
      height='22'
      viewBox='0 0 44 38'
      fill='none'
      className={className}
    >
      <line
        x1='1'
        y1='14'
        x2='8'
        y2='14'
        stroke='#00c4f8'
        strokeWidth='2'
        strokeLinecap='round'
        opacity='0.7'
      />
      <line
        x1='1'
        y1='19'
        x2='6'
        y2='19'
        stroke='#00c4f8'
        strokeWidth='1.5'
        strokeLinecap='round'
        opacity='0.5'
      />
      <line
        x1='1'
        y1='24'
        x2='8'
        y2='24'
        stroke='#00c4f8'
        strokeWidth='2'
        strokeLinecap='round'
        opacity='0.7'
      />
      <rect x='10' y='16' width='20' height='14' rx='2' fill='#00c4f8' />
      <rect
        x='22'
        y='18'
        width='6'
        height='7'
        rx='1'
        fill='white'
        opacity='0.8'
      />
      <rect x='10' y='8' width='3' height='22' rx='1' fill='#0098f7' />
      <rect x='7' y='28' width='6' height='2' rx='1' fill='#0098f7' />
      <rect x='7' y='32' width='6' height='2' rx='1' fill='#0098f7' />
      <circle cx='16' cy='31' r='3.5' fill='#43485b' />
      <circle cx='16' cy='31' r='1.5' fill='white' />
      <circle cx='27' cy='31' r='3.5' fill='#43485b' />
      <circle cx='27' cy='31' r='1.5' fill='white' />
      <circle cx='25' cy='16' r='3' fill='#0098f7' />
    </svg>
  );
}

function TruckParkedIcon() {
  return (
    <svg width='26' height='22' viewBox='0 0 44 38' fill='none'>
      <rect x='12' y='16' width='20' height='14' rx='2' fill='#d5d8ec' />
      <rect
        x='24'
        y='18'
        width='6'
        height='7'
        rx='1'
        fill='white'
        opacity='0.8'
      />
      <rect x='12' y='8' width='3' height='22' rx='1' fill='#a5aabd' />
      <rect x='9' y='28' width='6' height='2' rx='1' fill='#a5aabd' />
      <rect x='9' y='32' width='6' height='2' rx='1' fill='#a5aabd' />
      <circle cx='18' cy='31' r='3.5' fill='#888ea7' />
      <circle cx='18' cy='31' r='1.5' fill='white' />
      <circle cx='29' cy='31' r='3.5' fill='#888ea7' />
      <circle cx='29' cy='31' r='1.5' fill='white' />
      <circle cx='27' cy='16' r='3' fill='#a5aabd' />
      <path
        d='M36 2C33.791 2 32 3.866 32 6.16C32 9.28 36 14 36 14C36 14 40 9.28 40 6.16C40 3.866 38.209 2 36 2Z'
        fill='#d5d8ec'
      />
      <circle cx='36' cy='6' r='1.8' fill='white' />
    </svg>
  );
}

function TruckDropoffIcon() {
  return (
    <svg width='26' height='22' viewBox='0 0 44 38' fill='none'>
      <rect
        x='8'
        y='34'
        width='28'
        height='2.5'
        rx='1.25'
        fill='#c2e88a'
      />
      <rect
        x='8'
        y='34'
        width='6'
        height='2.5'
        rx='1.25'
        fill='#8fd854'
      />
      <rect
        x='18'
        y='34'
        width='6'
        height='2.5'
        rx='1.25'
        fill='#8fd854'
      />
      <rect
        x='30'
        y='34'
        width='6'
        height='2.5'
        rx='1.25'
        fill='#8fd854'
      />
      <rect x='12' y='16' width='20' height='14' rx='2' fill='#8fd854' />
      <rect
        x='24'
        y='18'
        width='6'
        height='7'
        rx='1'
        fill='white'
        opacity='0.85'
      />
      <rect x='12' y='8' width='3' height='22' rx='1' fill='#6db33f' />
      <rect x='9' y='28' width='6' height='2' rx='1' fill='#6db33f' />
      <rect x='9' y='32' width='6' height='2' rx='1' fill='#6db33f' />
      <circle cx='18' cy='31' r='3.5' fill='#43485b' />
      <circle cx='18' cy='31' r='1.5' fill='white' />
      <circle cx='29' cy='31' r='3.5' fill='#43485b' />
      <circle cx='29' cy='31' r='1.5' fill='white' />
      <circle cx='27' cy='16' r='3' fill='#6db33f' />
      <path
        d='M36 2C33.791 2 32 3.866 32 6.16C32 9.28 36 14 36 14C36 14 40 9.28 40 6.16C40 3.866 38.209 2 36 2Z'
        fill='#8fd854'
      />
      <circle cx='36' cy='6' r='1.8' fill='white' />
    </svg>
  );
}

function CheckmarkIcon() {
  return (
    <svg width='18' height='18' viewBox='0 0 24 24' fill='none'>
      <path
        d='M5 13l4 4L19 7'
        stroke='#a5aabd'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

interface WmsStepProps {
  icon: React.ReactNode;
  label: string;
  labelColor: string;
  iconBackground: string;
  iconBorder: string;
  opacity?: number;
}

function WmsStep({
  icon,
  label,
  labelColor,
  iconBackground,
  iconBorder,
  opacity,
}: WmsStepProps) {
  const { classes } = useStyles();

  return (
    <div className={classes.wmsStep} style={opacity ? { opacity } : undefined}>
      <div
        className={classes.wmsStepIcon}
        style={{
          background: iconBackground,
          border: `2px solid ${iconBorder}`,
        }}
      >
        {icon}
      </div>
      <span className={classes.wmsStepLabel} style={{ color: labelColor }}>
        {label}
      </span>
    </div>
  );
}

interface WmsStepperProps {
  currentStep: 'pickup' | 'dropoff';
}

export function WmsStepper({ currentStep }: WmsStepperProps) {
  const { classes } = useStyles();

  if (currentStep === 'pickup') {
    return (
      <div className={classes.wmsStepper}>
        <WmsStep
          icon={<TruckDrivingIcon className={classes.drivingTruck} />}
          label='Pickup'
          labelColor='#00c4f8'
          iconBackground='#dff7fe'
          iconBorder='#00c4f8'
        />
        <div className={classes.wmsTrack} />
        <WmsStep
          icon={<TruckParkedIcon />}
          label='Drop-off'
          labelColor='#a5aabd'
          iconBackground='#f5f6fe'
          iconBorder='#d5d8ec'
          opacity={0.35}
        />
      </div>
    );
  }

  return (
    <div className={classes.wmsStepper}>
      <WmsStep
        icon={<CheckmarkIcon />}
        label='Pickup'
        labelColor='#a5aabd'
        iconBackground='#f5f6fe'
        iconBorder='#d5d8ec'
        opacity={0.4}
      />
      <div className={classes.wmsTrack} />
      <WmsStep
        icon={<TruckDropoffIcon />}
        label='Drop-off'
        labelColor='#8fd854'
        iconBackground='#edfad0'
        iconBorder='#8fd854'
      />
    </div>
  );
}

const useStyles = makeStyles({ name: { WmsStepper } })(() => ({
  '@keyframes drive': {
    '0%,100%': { transform: 'translateX(0)' },
    '50%': { transform: 'translateX(3px)' },
  },
  wmsStepper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px 8px',
    gap: 12,
    width: '100%',
  },
  wmsStep: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    flex: '0 0 auto',
  },
  wmsStepIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  wmsStepLabel: {
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase' as const,
  },
  wmsTrack: {
    width: 60,
    flex: '0 0 60px',
    height: 2,
    borderRadius: 2,
    background: '#d5d8ec',
    marginBottom: 14,
  },
  drivingTruck: {
    animation: '$drive 0.6s ease-in-out infinite',
  },
}));
